import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['item'];

  connect() {}

  handleDragstart(event) {
    const dt = event.target.dataTransfer;
    event.dataTransfer.setData('item-id', event.target.dataset.itemId);
    event.dataTransfer.setData('item-move-path', event.target.dataset.itemMovePath);
  }

  handleDragenter(event) {
    const target = this.closestItem(event.target)
    if (target.dataset.itemType === 'folder-open') {
      target.classList.add('opacity-50')
    }
  }

  handleDragover(event) {
    event.preventDefault()
  }

  handleDragend(event) {
    event.preventDefault()
  }

  handleDragleave(event) {
    const target = this.closestItem(event.target)
    target.classList.remove('opacity-50')
    event.preventDefault()
  }

  handleDrop(event) {
    const dropItem = this.closestItem(event.target)
    dropItem.classList.remove('opacity-50')

    const dragItemId = event.dataTransfer.getData('item-id');
    const dragItemPath = event.dataTransfer.getData('item-move-path');
    const dropItemType = dropItem.dataset.itemType;
    const parentId = dropItem.dataset.itemId;
    if (dropItemType === 'file') {
      this.createToast({color: 'warning', message: 'You cannot drag / drop onto a file'});
      return;
    }

    if (dragItemId === parentId) {
      return;
    }
    fetch(dragItemPath, {
      method: 'PATCH',
      headers: this.headers(),
      body: new URLSearchParams({ parent_id: parentId })
    }).then((response) => {
      if (!response.ok) { return; }

      return response.json().then(({ color, message }) => {
        this.createToast({ color, message });
        if (color === 'success') {
          document.querySelector(`[data-item-id="${dragItemId}"]`).style.display = 'none';
        }
      })
    })
  }

  headers() {
    return {
      'Accept': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
      'X-Requested-With': 'XMLHttpRequest'
    }
  }

  closestItem(element) {
    while (element && !this.itemTargets.includes(element)) { element = element.parentElement; }
    return element
  }

  createToast({ color, message }) {
    const template = document.createElement('template')
    template.innerHTML = this.buildToast(color).trim()
    template.content.querySelector('.toast-body').textContent = message
    document.getElementById('toast-container').append(template.content)
  }

  buildToast(color) {
    return `
      <div class="toast show align-items-center text-white bg-${color} border-0 mb-4" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="d-flex">
          <div class="toast-body"></div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
      </div>
    `
  }
}
